import { Text } from 'ui-kit/typography'
import { useIsClient, useMediaQuery } from 'usehooks-ts'
import { Link } from 'ui-kit/actions/link/Link'
import { BuildingBlocksMarkupDataType } from './blocksData'
import { JigIcon } from './BuildingBlocksJigIcon'
import clsx from 'clsx'
import classes from './BuildingBlocks.module.scss'

export const BuildingBlocksCard = ({
  item,
}: {
  item: BuildingBlocksMarkupDataType
}) => {
  const { Icon, rotated, title, description, href, puzzleJigs } = item

  return (
    <li className={classes.item}>
      <Text size={'lg'} className={classes.title}>
        <Icon
          className={clsx(classes.icon, rotated && classes.icon__rotated)}
        />
        <Link href={href} target='_blank' className={classes.link}>
          {title}
        </Link>
      </Text>

      <Text className={classes.description}>{description}</Text>

      <PuzzleJigs jigs={puzzleJigs as Record<string, string[]>} />
    </li>
  )
}

const PuzzleJigs = ({ jigs }: { jigs: Record<string, string[]> }) => {
  const hasMounted = useIsClient()

  const { sm, md, lg, xl } = jigs

  const isMobile = useMediaQuery('(max-width: 767px)')
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 991px)')
  const isDesktop = useMediaQuery('(min-width: 992px) and (max-width: 1239px)')

  if (!hasMounted) return null

  let setOfJigs: string[] = []

  switch (true) {
    case isMobile:
      setOfJigs = sm
      break
    case isTablet:
      setOfJigs = md
      break
    case isDesktop:
      setOfJigs = lg
      break
    default:
      setOfJigs = xl
  }

  return (
    <>
      {setOfJigs.map((location) => (
        <JigIcon key={location} location={location} />
      ))}
    </>
  )
}
